<template>
	<div id="app">
		<xheader></xheader>
		<router-view></router-view>
		<xfooter></xfooter>
	</div>
</template>

<script>
import xheader from './components/xheader.vue';
import xfooter from './components/xfooter.vue';
export default{
	components:{
		xheader,xfooter
	}
}
</script>

<style lang="scss">
	body{
		background:#FFF;
	}
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		text-align: left;
		color: #333;
		padding-top: 77px;
	}
</style>